module.exports = __webpack_public_path__ + "static/media/empty-state-graphic-bar.64aefab3.svg";